import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
const CenteredModal = dynamic(() => import('@/components/layout/modals/CenteredModal'));
CenteredModal.displayName = 'CenteredModal';

import styles from './ProductViewLabelBio.module.scss';
import { ENVIRONNEMENT_DATA as bioData, ENVIRONNEMENT } from '@/constants/product';

const tooltipTarget = 'label-bio';
const tooltipSecondTarget = 'label-bio-demeter-biodyvin';

type ProductViewLabelBioProps = {
  t: (k: string) => string;
  environnement: any;
  isMobileView: boolean;
}

export const ProductViewLabelBio = ({ t, environnement, isMobileView }: ProductViewLabelBioProps): React.JSX.Element => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [isSecondTooltipOpen, setIsSecondTooltipOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { value, valueId } = environnement;
  const isBiodyvinOrDemeter = (valueId === ENVIRONNEMENT.BIODYVIN || valueId === ENVIRONNEMENT.DEMETER);
  const bioTitle = t('bioLabel.certificates');
  const agribioAlt = t('bioLabel.organic.alt');

  const toogleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const bioIcon = (
    <div className={styles['icon-container']}>
      <img
        id={tooltipTarget}
        src={bioData[valueId].src.icon}
        alt={value}
        onClick={isMobileView ? toogleModal : null}
        data-test-id="label-bio"
        height={24}
      />
      {isBiodyvinOrDemeter && (
        <img
          id={tooltipSecondTarget}
          src={bioData[ENVIRONNEMENT.AGRIBIO].src.icon}
          alt={agribioAlt}
          onClick={isMobileView ? toogleModal : null}
          data-test-id="label-demeter"
          height={24}
        />
      )}
    </div>
  );
  const bioContent = <p className={styles.text} data-test-id="bio-message">{t(bioData[valueId].desc)}</p>;

  const demeterAndBiodyvinContent = (
    <>
      {bioContent}
      <p className={styles.text} data-test-id="agribio-message">
        {t(bioData[ENVIRONNEMENT.AGRIBIO].desc)}
      </p>
    </>
  );

  return (
    <>
      {bioIcon}
      {isMobileView ? (
        <CenteredModal
          opened={isModalOpen}
          title={bioTitle}
          customContent={isBiodyvinOrDemeter ? demeterAndBiodyvinContent : bioContent}
          cancelAction={toogleModal}
          fullWidth
        />
      ) : (
        <>
          {isBiodyvinOrDemeter && (
            <Tooltip
              placement="top"
              target={tooltipSecondTarget}
              isOpen={isSecondTooltipOpen}
              toggle={() => setIsSecondTooltipOpen(!isSecondTooltipOpen)}
              className={styles['custom-tooltip']}
            >
              {demeterAndBiodyvinContent}
            </Tooltip>
          )}
          <Tooltip
            placement="top"
            target={tooltipTarget}
            isOpen={isTooltipOpen}
            toggle={() => setIsTooltipOpen(!isTooltipOpen)}
            className={styles['custom-tooltip']}
          >
            {bioContent}
          </Tooltip>
        </>
      )}
    </>
  );
};

export default ProductViewLabelBio;
